import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "home relative h-full" }
const _hoisted_2 = {
  key: 1,
  class: "absolute z-1 inset-0 flex items-center justify-center"
}
const _hoisted_3 = {
  id: "order-button",
  class: "fixed z-19 bottom-[80px] left-1/2 transform -translate-x-1/2 -translate-y-1/2"
}
const _hoisted_4 = { class: "text-gray-500 w-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParallelEditErrorModal = _resolveComponent("ParallelEditErrorModal")!
  const _component_OrderOverview = _resolveComponent("OrderOverview")!
  const _component_db_button = _resolveComponent("db-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ParallelEditErrorModal),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.store?.state?.OrderStore?.orders.length)
        ? (_openBlock(), _createBlock(_component_OrderOverview, {
            key: 0,
            orders: (_ctx.store?.state?.OrderStore?.orders as Order[]),
            onRefreshData: _ctx.refreshData
          }, null, 8, ["orders", "onRefreshData"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_db_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/orders/create'))),
                class: "hydrated",
                variant: "brand-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("order.add")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("order.empty")), 1)
          ]))
    ])
  ], 64))
}